import i18n from 'src/lib/i18n/i18n';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import PopupBasicLazy from '../../components/popups/PopupBasicLazy';
import AssetGroup from '@play-co/timestep-core/lib/ui/resource/AssetGroup';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Native, NativePromoOrigin } from 'src/replicant/native';
import { duration } from 'src/replicant/utils/duration';
import StateObserver from 'src/StateObserver';
import platform, { analytics } from '@play-co/gcinstant';
import { trackCrossplayPopupOpen } from '../../../lib/analytics/events';

export default class PopupLoginCrossplay extends PopupBasicLazy {
  private firstClick = true;
  private launchAttemptTimestamp: number;

  static assetsGroup = new AssetGroup(['assets/native/generic_icon.png']);

  protected getAssetsGroup(): AssetGroup {
    return PopupLoginCrossplay.assetsGroup;
  }

  constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      skipMessage: true,
      height: 550,
      tracking: { feature: 'crossplay', $subFeature: 'popup-login-crossplay' },
    });

    // game icon
    this.box.addSubview(
      new ImageView({
        x: this.box.style.width * 0.5,
        y: 265,
        width: 429,
        height: 403,
        centerOnOrigin: true,
        centerAnchor: true,
        image: 'assets/native/generic_icon.png',
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        x: this.box.style.width * 0.5,
        y: 475,
        width: 265,
        height: 90,
        fontSize: 31,
        font: 'Body',
        centerOnOrigin: true,
        centerAnchor: true,
        localeText: () => i18n('native.crossplay.login.cta'),
        onClick: async () => this.handleCrossplayClick(),
        tracking: {
          feature: 'crossplay',
          $subFeature: 'popup-login-crossplay-login',
        },
      }),
    );
  }

  async init(opts: { origin: NativePromoOrigin }) {
    super.init({
      title: i18n('native.crossplay.login.title'),
    });

    trackCrossplayPopupOpen(opts.origin);
  }

  private handleCrossplayClick() {
    if (this.firstClick) {
      // Hope that the app is still installed
      // Nothing will happen for this click if its uninstalled
      this.firstClick = false;
      this.launchAttemptTimestamp = StateObserver.now();

      const switchPayload = {
        ...platform.entryData,
        isAppSwitch: true,
      };
      const switchPayloadText = encodeURIComponent(
        JSON.stringify(switchPayload),
      );
      const deepLink = `${Native.ruleset.nativeAppLaunchUrl}?payload=${switchPayloadText}`;
      analytics.pushEvent('LiffLoginCrossplaySwitch', {
        deepLinkLength: deepLink.length,
      });
      window.location.assign(deepLink);

      // Continue launch sequence in case player comes back to LINE
      this.opts.close();
    } else if (
      // Adding delays before the 2nd click attempt,
      // if that's the case then its very likely no redirect happened (app uninstalled)
      StateObserver.now() >
      this.launchAttemptTimestamp + duration({ seconds: 1 })
    ) {
      // Close the popup, continue playing
      this.opts.close();
    }
  }
}
